import { useCallback } from "react";
import { getCompletionDataFieldDef } from "../../api/CompletionData";
import { getFieldsByGroup } from "../../models/workorders/WorkOrder";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetValidStatusValues() {
  const setWoValidStatusValues = useWorkOrderStore(
    (state) => state.setWoValidStatusValues
  );

  const getValidStatusValues = useCallback(
    async (woNumber: string) => {
      const metadata = await getCompletionDataFieldDef();
      const fields = metadata.data ? getFieldsByGroup(metadata.data) : [];
      const statusField = fields.find((field) => {
        return field.ColumnName === "status";
      });
      if (statusField?.ValidValues) {
        const values = statusField.ValidValues.filter((value) => {
          return +value.Code < 70 || +value.Code >= 80;
        });
        setWoValidStatusValues(woNumber, values);
      } else {
        setWoValidStatusValues(woNumber, []);
      }
    },
    [setWoValidStatusValues]
  );

  return { getValidStatusValues };
}
